<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2872.06"
    height="1037.541"
    viewBox="0 0 2872.06 1037.541"
  >
    <path
      id="Path_235"
      data-name="Path 235"
      d="M-11.892,220.663,5.25,219.477l101.1-6.993,106.86-7.723,88.6-9.946,88.119-16.406,36.422-9.579s12.822-4.023,22.111-6.581c1.32-.363,15.561-5.932,22.825-8.242,1.067-.339,16.7-5.971,35.222-13.723,11.015-4.609,42.832-20.16,57.523-27.958,1.069-.567,13.375-7.732,19.952-11.554,1.281-.744,12.7-7.552,18.917-11.257,1.407-.838,32.3-21.125,46.974-30.762,2.685-1.763,21.041-15.583,21.041-15.583l27.434-22.48S712.609,7.672,723.022-3.324a230.227,230.227,0,0,0,16.983-19.969s4.991-6.026,11.73-18.132,4.567-7.609,9.427-18.376c1.286-2.849,4.936-15.89,6.052-19.5.126-.407,3.106-12.884,3.6-32.72a139.04,139.04,0,0,0-1.97-19.149c-.837-4.859-2.4-7.685-3.782-13.333-.516-2.107-4.515-11.785-4.515-11.785s-4.184-6.848-8.239-13.066a41.16,41.16,0,0,0-7.524-8.386,88.651,88.651,0,0,0-9.867-9.631,103.941,103.941,0,0,0-15.226-10.613c-4.008-2.377-7.034-4.183-9.538-5.463-5.935-3.035-6.417-2.881-11.4-5.266a108.567,108.567,0,0,0-10.432-3.985c-3.727-1.239-10.712-3.114-15.854-4.518-7.034-1.921-14.374-3.189-21.144-4.346a165.852,165.852,0,0,0-26.85-2.858c-4.549-.192-11.118-.265-18.089-.023-2.708.093-11.377,1.149-11.377,1.149s-4.833.579-9.617,1.624a61.754,61.754,0,0,0-9.519,2.555,102.822,102.822,0,0,0-9.9,3.646,54.4,54.4,0,0,0-8.681,4.734,23.043,23.043,0,0,0-4.61,3.474l-3.361,2.734-4.8,4.821c-2.669,3.384-3.736,3.485-8.409,10.956a81.281,81.281,0,0,0-7.588,19.773c-.062.238-1.584,10.51-2.462,17.516-.285,2.275.125,13.018.662,22.993a157.781,157.781,0,0,0,3.55,23.628c1.54,6.779,2.558,13.046,4.149,19.361,1.935,7.683,4.092,13.118,5.3,17.691,0,.014,4.923,14.26,7.521,21.438a52.365,52.365,0,0,0,2.871,7.274c3.123,7.348,11.066,24.271,13.312,29.122.643,1.39,5.623,11.805,13.784,25.754S585.22,30.5,595.528,45.168s22.916,29.324,22.916,29.324,14.288,12.717,27.3,22.389c2.705,2.012,26.927,18.668,42.917,27.1,14.032,7.7,30.115,15.738,56.28,26.459,5.921,2.277,20.5,8.689,37.907,13.8,2.891,1.074,13.32,4.62,31.13,9.871,16.322,4.257,25.572,7.2,42.2,10.969,14.95,3.384,37.758,7.719,40.973,8.278,16.748,3.041,34.948,5.733,46.616,7.238,19.482,2.514,34.475,3.99,45.745,5.284,33.1,2.362,61,3.074,62.762,3.1,8.252.109,11.4.343,24.92.3s15.564.131,29.151-.483c10.239-.463,25.653-1.662,25.653-1.662s16.914-.638,34.247-2.515c11.327-1.227,37.682-5.64,44.885-6.516,3-.364,28.388-5.792,45.262-9.211,1.654-.335,25.752-6.615,52.5-15.064,24.94-7.879,53.151-17.727,60.568-20.342,2.656-.937,53.173-19.137,72.582-25.982,3.417-1.205,67.7-22.092,88.995-28.713,1.718-.534,40.085-10.811,40.085-10.811s40.43-11.075,69.856-17.351c16.773-3.577,23.4-4.5,30.855-5.641,5.1-.783,10.424-1.857,22.745-3.429,9.914-1.265,20.519-3.153,30.219-4.2,17.432-1.873,31.3-2.448,31.3-2.448l50.236-1.573,63.127,4.735s21.829,3.459,37.14,5.606c4.89.686,28.672,6.1,46.2,9.976,4.553,1.008,26.6,8.066,39.664,11.552,4.13,1.1,27.594,9.675,41.264,15.689,4.046,1.78,22.365,10.225,36.678,17.152,4.425,2.142,23.175,13.6,35.765,20.894,4.908,2.844,23.947,18.242,36.923,29.184,3.661,3.087,18.01,17.964,29.118,29.636,3.5,3.68,11.42,16.868,18.385,28.9,3.78,6.53,7.069,15.936,10.083,24.638,2.072,5.981,1.773,6.781,4.118,23.026.258,1.791-2.793,15.332-4.013,23.044-.259,1.634-7.183,15.007-10.577,20.186-1.485,2.266-10.214,11.359-17.249,18.088-2.587,2.475-19.133,11.828-31.99,18.338-3,1.518-22.672,8.141-36.5,11.9a381.293,381.293,0,0,1-43.886,6.6c-13.923,1.248-36.682,1.485-44.006,1.943-3.173.2-27.956-.772-42.061-.88-2.907-.022-52.29-5.225-73.241-7.584-3.81-.429-49.949-10.165-70.93-15.774a569.163,569.163,0,0,1-54.4-17.708c-21.685-8.362-44.266-19.979-52.022-23.4-2.117-.935-27.4-15.67-40.061-23.594-2.236-1.4-28.11-21.906-36.03-27.869-1.163-.875-10.769-10.433-17.952-18.5-4.839-5.431-14.445-16.9-19.074-21.8-2.184-2.31-11.552-19.941-18.323-30.6-.126-.2-2.5-6.281-4.792-11.688-.691-2.383-1.65-6.01-2.606-9-1.287-4.026-4.12-15.167-4.12-15.167s-3.251-15.728-2.849-24.217a157.366,157.366,0,0,1,.208-18.429c.729-9.424.342-7.19,3.621-18.726a159.434,159.434,0,0,1,13.807-33.512c13.671-24.2,27.921-35.375,36.917-45.124,1.02-1.106,21.379-17.123,35.724-25.556s11.825-7.151,23.061-12.627c9.511-4.634,19.672-9.23,26.086-12.2,1.507-.7,33.8-11.893,33.8-11.893s35.344-9.93,43.954-12.681c2.239-.715,35.493-6.911,55.692-10.647,5.935-1.1,51.355-6.424,77.932-9.506,8-.928,49.149-3.064,69.616-4.093,4.945-.249,43.149-.71,62.074-.927,4.4-.05,44.111,1.059,63.956,1.624,4.771.136,45.223,2.2,64.52,3.195,4.5.231,84.04,4.978,115.757,6.873,6.567.392,124.714,8.331,156.53,10.469,3.943.265,126.14,10.626,161.708,13.643,5.031.427,129.42,11.632,161.963,14.564l7.295.657"
      transform="translate(48.639 638.112) rotate(-8)"
      fill="none"
      stroke="#ced5cc"
      stroke-width="54"
      opacity="0.30"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style scoped>
svg {
  width: 100%;
  height: auto;
  transform: scale(2.1) translate(10%, -6%);
}

@media (max-width: 1263px) {
  svg {
    transform: scale(2.3) translate(10%, -6%);
  }
}

@media (max-width: 959px) {
  svg {
    transform: scale(3) translate(14%, -10%);
  }
}

@media (max-width: 767.98px) {
  svg {
    transform: scale(4) translate(17%, -13%);
  }
}

@media (max-width: 599px) {
  svg {
    transform: scale(4.6) translate(18%, -16%);
  }
}

@media (max-width: 480px) {
  svg {
    transform: scale(4.6) translate(18%, -30%);
  }
}

@media (max-width: 350px) {
  svg {
    transform: scale(5.2) translate(20%, -58%);
  }
}
</style>

<style>
/* Animation */
.contact-form-animation {
  stroke-dasharray: 5326;
  stroke-dashoffset: 0;
  -webkit-animation: animate-Path_235 4s ease-in forwards;
  animation: animate-Path_235 4s ease-in forwards;
}

@-webkit-keyframes animate-Path_235 {
  from {
    stroke-dashoffset: 5326;
  }
}

@keyframes animate-Path_235 {
  from {
    stroke-dashoffset: 5326;
  }
}
</style>